import PerformanceBar from '../PerformanceBar';
import PerformanceDetails from '../PerformanceDetails';
import PropTypes from 'prop-types';
import PopOver from 'chameleon/ui-stack/ui/base/popover';
import React from 'react';
import cn from 'classnames';
import { Link as RouterLink } from 'react-router';
import Button from 'chameleon/ui-stack/ui/base/button';

export const questionTiers = [
  {
    label: 'Correct',
    topLimit: 100,
    bottomLimit: 2,
    type: 'correct',
  },
  {
    label: 'Incorrect',
    bottomLimit: 0,
    topLimit: 1,
    type: 'incorrect',
  },
];

export const questionFRQTiers = [
  {
    label: 'Full Credit',
    topLimit: 100,
    bottomLimit: 100,
    type: 'correct',
  },
  {
    label: 'Partial Credit',
    topLimit: 99,
    bottomLimit: 2,
    type: 'partial',
    isHiddenByDefault: true,
  },
  {
    label: 'No Credit',
    bottomLimit: 0,
    topLimit: 1,
    type: 'incorrect',
  },
];

const PerformanceBarPopover = ({
  stacks,
  ariaLabel,
  ariaDescribedBy,
  studentUrl,
  contentOffset,
  perfDetailsTitle,
  perfDetailsFooter,
  showFooter,
  isWeighed,
  showScore,
  disableNoResultsLink,
  resultsUrl,
  fullWidth = false,
  disabled,
  assignmentProgressText,
  assignmentProgressLink,
  onProgressBarClick,
  ...props
}) => (
  <PopOver
    showCloseButton
    className={cn('progress_details_popover popover_underneath', {
      'w-full': fullWidth,
      'cursor-default': disabled,
    })}
    buttonClassName="w-full"
    size="full"
    contentOffset={contentOffset}
    disabled={disabled}
    accessibility={{
      'aria-label': ariaLabel,
      'aria-describedby': ariaDescribedBy,
      // Test attribute
      'data-test-perf-details-popover': '',
    }}
    trigger={
      onProgressBarClick ? (
        <div onClick={onProgressBarClick} role="link" tabIndex={0}>
          <PerformanceBar data-test-perf-bar isSmall stacks={stacks} />
        </div>
      ) : (
        <PerformanceBar data-test-perf-bar isSmall stacks={stacks} />
      )
    }
    {...props}
  >
    <PerformanceDetails
      showScore={showScore}
      isWeighted={isWeighed}
      id={ariaDescribedBy}
      stacks={stacks}
      studentUrl={studentUrl}
      title={perfDetailsTitle}
      footer={perfDetailsFooter}
      showFooter={showFooter}
      disableNoResultsLink={disableNoResultsLink}
    />
    <div className="flex flex-row justify-end items-center">
      {assignmentProgressLink && (
        <RouterLink className="mr-5" to={assignmentProgressLink}>
          <Button
            tabIndex={0}
            accessibility={{
              'aria-label': assignmentProgressText,
            }}
            className="bg-white border border-blue-500"
          >
            {assignmentProgressText}
          </Button>
        </RouterLink>
      )}
      {resultsUrl && (
        <RouterLink to={resultsUrl}>
          <Button
            tabIndex={0}
            accessibility={{
              'aria-label': 'View Results',
            }}
            isPrimary
          >
            View Results
          </Button>
        </RouterLink>
      )}
    </div>
  </PopOver>
);

PerformanceBarPopover.propTypes = {
  stacks: PropTypes.array.isRequired,
  ariaLabel: PropTypes.string.isRequired,
  ariaDescribedBy: PropTypes.string.isRequired,
  studentUrl: PropTypes.string,
  contentOffset: PropTypes.string,
  perfDetailsTitle: PropTypes.element,
  perfDetailsFooter: PropTypes.element,
  showFooter: PropTypes.bool,
  showScore: PropTypes.bool,
  disableNoResultsLink: PropTypes.bool,
};

PerformanceBarPopover.defaultProps = {
  studentUrl: '/',
  contentOffset: '0 0 0 0',
  perfDetailsTitle: null,
  perfDetailsFooter: null,
  showFooter: false,
  showScore: true,
  disableNoResultsLink: false,
};

export default PerformanceBarPopover;
